import { render, staticRenderFns } from "./participant_submissions.vue?vue&type=template&id=6089a096&scoped=true&"
import script from "./participant_submissions.vue?vue&type=script&lang=js&"
export * from "./participant_submissions.vue?vue&type=script&lang=js&"
import style0 from "./participant_submissions.vue?vue&type=style&index=0&id=6089a096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089a096",
  null
  
)

export default component.exports